import { ActiveForm } from '@/components/form/ActiveSwitch';
import HeaderContainerForm from '@/components/headerContainer/Form';
import { formatDateTime } from '@/utils';
import history from '@/utils/history';

function DatasourceHeading({ data, active, onChangeActive }) {
  return <>
    <HeaderContainerForm
      title='Datasource'
      data={{ ...data, createdAt: formatDateTime(data?.created_at), updatedAt: formatDateTime(data?.updated_at) }}
      onCancel={() => history.goBack()}
    >
      <ActiveForm active={active} onChangeActive={onChangeActive} />
    </HeaderContainerForm>
  </>
}

export default DatasourceHeading
